export const tr = {
    campaign_context_enable_cpc_hold: 'Ortalama tıklama fiyatını aramadaki ortalama tıklama fiyatının altında tut',
    campaign_context_limit: 'Harcamayı kampanyanın toplam harcama limitinde {oldLimitPercent} {newLimitPercent} tut',
    campaign_context_price_coef:
        'Maksimum tıklama fiyatı aramada belirtilen fiyatın {oldPriceCoef} {newPriceCoef} kadarı olsun'
};
